import React, { useState } from "react";
import Modal from "../../../../Common/Modal";
import RollerLoadingAnimation from "./RollerLoadingAnimation";
import MtiButton from "../../../../Buttons/MtiButton";
import "./CalibrationProgressModal.css";
import { ESuiteModeState } from "../../../../../Model/ModuleState";

type Props = {
  show: boolean;
  onHide: () => void;
  stopCalibration: () => void;
  autoCalibratingState: ESuiteModeState;
};

export default function CalibrationProgressModal({
  show,
  onHide,
  stopCalibration,
  autoCalibratingState,
}: Props) {
  const [doFadeOut, setDoFateOut] = useState(false);

  const onClickTerminate = () => {
    if (autoCalibratingState !== ESuiteModeState.Stopping) {
      stopCalibration();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      hideOnBackdropClick={false}
      className={
        doFadeOut
          ? "auto-calibration-progress-modal calibrating-done"
          : "auto-calibration-progress-modal"
      }
    >
      <Modal.Header
        title={"Calibration Process"}
        hideButtonEnabled={false}
        className="auto-calibration-progress-header"
      />
      <Modal.Body className="auto-calibration-progress-body">
        <RollerLoadingAnimation />
        <div className="progress-title">
          {autoCalibratingState !== ESuiteModeState.Stopping ? (
            <p>
              Please wait,
              <br />
              Calibration is in progress...
            </p>
          ) : (
            <p>The auto-calibration is being terminated</p>
          )}
        </div>
        <div className="progress-subtittle">
          {autoCalibratingState !== ESuiteModeState.Stopping
            ? "The system won't save any data if you terminate this process."
            : "Please waiting process till end. The Auto Calibration process auto canceled when this process is done."}
        </div>
        {autoCalibratingState !== ESuiteModeState.Stopping ? (
          <MtiButton
            variant="secondary"
            colorVariant="error"
            size="large"
            onClick={onClickTerminate}
            style={{
              width: 191,
              alignSelf: "flex-end",
            }}
            disabled={false}
          >
            <span>TERMINATE</span>
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM8 2L9 12H11L12 2H8ZM10 18C11.1046 18 12 17.1046 12 16C12 14.8954 11.1046 14 10 14C8.89543 14 8 14.8954 8 16C8 17.1046 8.89543 18 10 18Z"
                fill="#DB0000"
              />
            </svg>
          </MtiButton>
        ) : (
          <div style={{ height: 47 }}></div>
        )}
      </Modal.Body>
    </Modal>
  );
}
